// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UfoIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UfoIcon" ref={forwardedRef} {...props}>
      <path d="M9.25 2.25h1.5v2.037c1.829.188 3.073 1.058 3.859 2.15.665.925.984 1.979 1.094 2.85a2.75 2.75 0 0 1 .55 5.275L17.04 17.5l-1.449.388-.841-3.139h-4V18h-1.5v-3.25h-4l-.84 3.14-1.45-.39.788-2.94a2.75 2.75 0 0 1 .549-5.274c.11-.871.429-1.925 1.094-2.85.786-1.092 2.03-1.963 3.86-2.15zm6 8.5H4.75a1.25 1.25 0 1 0 0 2.5h10.5a1.25 1.25 0 1 0 0-2.5m-1.069-1.5c-.107-.615-.348-1.324-.79-1.937C12.781 6.465 11.756 5.75 10 5.75S7.22 6.465 6.609 7.313C6.167 7.926 5.926 8.635 5.819 9.25z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UfoIcon = /* @__PURE__ */ Object.assign(UfoIconComponent, {
  displayName: 'UfoIcon',
});
